function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "kazakhmys 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "\xD0\xA1\xD0\xBB\xD0\xBE\xD0\xB9_x0020_1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M109.377 67.2053C58.9106 67.2053 18.0376 52.441 18.0376 34.1946C18.0376 17.8982 50.736 4.38746 93.7708 1.67139C42.2912 3.06424 1.68848 19.2214 1.68848 39C1.68848 59.6142 46.142 76.3982 101 76.3982C155.857 76.3982 200.311 59.6839 200.311 39C200.311 38.5125 200.311 38.0946 200.243 37.6767C195.446 54.2517 156.6 67.2053 109.377 67.2053Z",
  fill: "#FFC731"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.754 74.866C62.8965 74.866 18.443 58.291 18.443 37.8857C18.443 20.0571 52.2223 5.22317 97.1487 1.67139C44.1152 2.36782 1.68848 18.8035 1.68848 39C1.68848 59.6142 46.142 76.3982 101 76.3982C112.079 76.3982 122.821 75.7017 132.752 74.4482C127.888 74.7267 122.888 74.866 117.754 74.866Z",
  fill: "#0CB5DD"
}), /*#__PURE__*/React.createElement("g", {
  id: "_152200352"
}, /*#__PURE__*/React.createElement("path", {
  id: "_152205248",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.9095 37.1893L65.3283 32.6625H65.3958L66.6794 37.1893H63.9095ZM64.3825 27.7875C63.7744 27.7875 63.234 28.1358 62.8286 28.5536L57.7617 42.3429H62.2881L62.9637 40.2536H67.6253L68.2333 42.3429H72.8948L67.5577 27.7179L64.3825 27.7875Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152209904",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M85.3934 31.8964L85.7312 31.4785C86.0014 31.1303 86.1366 30.7125 86.1366 30.2946V27.7875H73.8409V31.5482H80.259L73.8409 38.4428C73.6382 38.7214 73.5031 39.0696 73.4355 39.4875V42.4125H86.4743V38.6518H79.3131L85.3934 31.8964Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152210096",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.287 33.4982C171.193 32.9411 169.166 32.7321 169.031 31.6875C169.031 30.8518 170.044 30.7125 170.652 30.7125C171.125 30.7125 171.598 30.7821 172.004 31.0607C172.341 31.3393 172.612 31.6875 172.544 32.2446H176.8C176.665 28.6928 173.895 27.5089 170.72 27.5089C167.747 27.5089 164.842 28.9714 164.842 32.3143C164.842 35.2393 167.477 35.8661 169.774 36.5625C172.274 37.2589 172.949 37.4678 172.949 38.2339C172.949 39.3482 171.801 39.5571 171.058 39.5571C170.247 39.5571 169.234 39.3482 168.896 38.5125C168.761 38.2339 168.761 37.9553 168.761 37.5375H164.234C164.302 42.2036 168.963 42.7607 170.652 42.7607C173.895 42.7607 177.408 41.5071 177.408 37.7464C177.408 35.0303 175.382 34.0553 173.287 33.4982Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152210288",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M142.683 29.0411L140.927 36.3536H140.859L139.103 29.1108C138.967 28.3447 138.359 27.7875 137.549 27.7875H132.347V42.4125H136.603V33.0108H136.67L139.238 42.3429H142.616L145.115 33.0108H145.183V42.3429H149.439V27.7179H144.237C143.426 27.8572 142.818 28.3447 142.683 29.0411Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152210480",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M161.599 27.7875C160.991 27.7875 160.451 28.1358 160.045 28.5536L157.883 33.15L155.789 28.5536C155.789 28.5536 155.789 28.5536 155.789 28.484C155.451 28.0661 154.911 27.7875 154.303 27.7179H150.52L155.654 36.9108V42.2733H160.18V36.9108L165.382 27.7179L161.599 27.7875Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152210672",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.0947 37.1893L94.5135 32.6625H94.581L95.8646 37.1893H93.0947ZM93.5677 27.7875C93.5001 27.7875 93.4325 27.7875 93.365 27.7875H93.2974C93.2299 27.7875 93.2299 27.7875 93.1623 27.7875C93.0947 27.7875 93.0947 27.7875 93.0272 27.8571H92.9596C92.8921 27.8571 92.8921 27.9268 92.8245 27.9268C92.8245 27.9268 92.8245 27.9268 92.757 27.9268C92.6894 27.9268 92.6218 27.9964 92.6218 27.9964C92.5543 27.9964 92.4867 28.0661 92.4867 28.1357C92.4192 28.2053 92.3516 28.2053 92.3516 28.275C92.284 28.3446 92.284 28.3446 92.2165 28.4143C92.2165 28.4839 92.1489 28.4839 92.1489 28.5536L87.082 42.2732H91.6085L92.284 40.1839H96.9456L97.5536 42.2732H102.215L96.878 27.6482L93.5677 27.7875Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152211032",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M126.334 32.8714H122.146V27.7875H117.619V42.4125H122.146V36.6321H126.334V42.4125H130.861V27.7875H126.334V32.8714Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152210864",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M57.2215 27.7875H52.5599C51.9519 27.7875 51.4114 28.1357 51.0061 28.5535L47.6282 32.8018H47.5606V27.7875H43.0342V42.4125H47.5606V38.0946L48.3037 37.2589L51.5466 42.4125H56.9512L51.2763 34.0553L57.2215 27.7875Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "_152211296",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.673 27.7875H112.011C111.403 27.7875 110.863 28.1357 110.457 28.5535L107.079 32.8018H107.012V27.7875H102.485V42.4125H107.012V38.0946L107.755 37.2589L110.998 42.4125H116.402L110.727 34.0553L116.673 27.7875Z",
  fill: "white"
}))));

const SvgLogo = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 202,
  height: 78,
  viewBox: "0 0 202 78",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.dc7bf865.svg";
export { ForwardRef as ReactComponent };